import { SESSION_RESULTS_GRAPH_COLORS } from '@/constants/colors';
import { toUnixMillis } from '@/helpers/timeFormaterHelper';

export const reportsComparison = {
    namespaced: true,

    state: {
        sessions: [],
        sessionFiles: {},
        ergstickFiles: {},
        filter: {
            sessions: []
        }
    },

    getters: {
        filter(state) {
            return state.filter;
        },

        sessions(state) {
            return _.sortBy(state.sessions, ({ start_date }) => toUnixMillis(start_date));
        },

        filteredSessions(state) {
            const sessions =
                !state.filter.sessions.length || state.filter.sessions.length === state.sessions.length
                    ? state.sessions
                    : state.sessions.filter(({ id }) => state.filter.sessions.includes(id));
            return _.sortBy(sessions, ({ start_date }) => toUnixMillis(start_date));
        },

        sessionFiles(state) {
            return state.sessionFiles;
        },

        filteredSessionFiles(state) {
            if (!state.filter.sessions.length) return state.sessionFiles;
            return Object.keys(state.sessionFiles)
                .filter(key => state.filter.sessions.includes(Number(key)))
                .reduce((obj, key) => {
                    obj[key] = state.sessionFiles[key];
                    return obj;
                }, {});
        },

        ergstickFiles(state) {
            return state.ergstickFiles;
        }
    },

    mutations: {
        resetState(state) {
            state.sessions = [];
            state.sessionFiles = {};
            state.ergstickFiles = {};
            state.filter = {
                sessions: []
            };
        },

        setSessions(state, sessions) {
            sessions.forEach((session, i) => {
                const index = state.sessions.findIndex(({ id }) => id === session.id);
                if (index === -1) {
                    Vue.set(session, 'color', SESSION_RESULTS_GRAPH_COLORS[i]);
                    state.sessions.push(Object.freeze(session));
                }
            });
        },

        setSessionFile(state, data) {
            Vue.set(state.sessionFiles, data.sessionId, data.file);
        },

        setErgstickFile(state, data) {
            Vue.set(state.ergstickFiles, data.sessionId, data.file);
        }
    }
};

export default reportsComparison;
